import React, { useEffect, useRef, useState } from "react"
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap"
import PropTypes from "prop-types"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useLocation, withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import usePermission from "helpers/permission/usePermission"
import { getCompanies, getCompaniesValuesByOptions, getCompanyOption } from "../../helpers/utils"
import FormFilterCompany from "../../components/Common/form-filter-company"
import IAPromptsTable from "./ai-prompts-table"
import { navegarBreadCrumb } from "../../store/navigator/actions"
import { apiRemoverIAPrompt } from "../../helpers/backend_helper"
import swal from "sweetalert"
import { Filters } from "../../common/data/definitions"

const AiPromptsLista = props => {
  const ref = useRef()
  const [filters, setFilters] = useState([])
  const [companies, setCompanies] = useState([])
  const [companiesOption, setCompaniesOption] = useState([])
  const location = useLocation()
  const translate = props.t

  const usePermissionInsert = usePermission("aiPrompt_inserir")
  const usePermissionEdit = usePermission("aiPrompt_editar")
  const usePermissionRemove = usePermission("aiPrompt_excluir")
  const possuiVinculo = (props.user?.vinculos || []).some(vinculo => ["A", "T"].includes(vinculo.vinculo_status))

  const isInforangra = props.user?.usuario_info
  const isAdmin = props.user?.usuario_info && props.user?.usuario_info?.perfil?.administrador && Array.isArray(props.empresas)

  useEffect(() => {
    if (!isInforangra) return
    if (props.dashboardFilters.companiesSelected) {
      setCompanies(props.dashboardFilters.companiesSelected)
    }

    populateFiltros(props.dashboardFilters.companiesSelected)

    props.navegarBreadCrumb({
      title: `Manutenções > Prompts de IA`,
      link: location.pathname
    })
  }, [])

  useEffect(() => {
    if (!isInforangra) return

    if (isAdmin) {
      let companiesOptions = props.empresas.map(empresa =>
        getCompanyOption(empresa)
      )
      setCompaniesOption(companiesOptions)

    } else {
      let companiesOptions = getCompanies(props.user)
      setCompaniesOption(companiesOptions)
    }

    return () => setCompaniesOption([])
  }, [props.user, props.empresas])

  const populateFiltros = companiesSelected => {
    const f = []

    let selected = []
    if (Array.isArray(companiesSelected) && companiesSelected.length > 0) {
      selected = companiesSelected
    } else {
      selected = companies
    }

    if ((Array.isArray(selected) && selected.length > 0) || !isAdmin) {
      f.push({ id: "idEmpresa", value: getCompaniesValuesByOptions(selected) })
    } else if (isAdmin) {
      f.push({ id: "ignoreCompany", value: true, condition: Filters.equals })
    }

    setFilters(f)
  }

  const pesquisar = () => {
    populateFiltros()
    setTimeout(() => ref?.current?.search(), 300)
  }

  const goTo = item => {
    props.history.push("/ai-prompt" + (item ? `/${item.id}` : ""))
  }

  if (!isInforangra) return null

  const removerPrompt = async data => {
    try {
      await apiRemoverIAPrompt({ id: data.id })
      swal({ title: "Exclusão realizada com sucesso!", icon: "success" }).then(
        () => ref?.current?.search()
      )
    } catch (error) {
      swal({
        title: "Gerou erro ao excluir o prompt de IA!",
        icon: "error",
        text: error?.response?.data?.message ? error?.response?.data?.message : error?.response?.data
      }).then()
    }

  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs
          title={translate("ai.prompt.title")}
          breadcrumbItem={translate("breadcrumb.ai.prompt")}
        />
        <Card>
          <CardBody>
            <Row className="mb-4">
              <Col md={6} xl={4}>
                <FormFilterCompany
                  attribute="companies"
                  value={companies}
                  setValue={value => setCompanies(value)}
                  options={companiesOption}
                  multiple={true}
                  hasSelectAll={!(props.user?.usuario_info && props.user?.usuario_info?.perfil?.administrador)}
                />
              </Col>
              <Col className="d-flex align-items-end gap-2">
                <Button color="primary" onClick={pesquisar}>
                  Buscar
                </Button>
                {usePermissionInsert && (
                  <Button color="success" onClick={() => goTo(null)}>
                    Cadastrar
                  </Button>
                )}
              </Col>
            </Row>

            <IAPromptsTable
              ref={ref}
              filters={filters}
              history={props.history}
              usePermissionRemove={usePermissionRemove}
              usePermissionEdit={usePermissionEdit}
              navegarEditarPrompt={goTo}
              removerPrompt={(data) => removerPrompt({ id: data.id })}
              t={translate}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

AiPromptsLista.propTypes = {
  user: PropTypes.any,
  empresas: PropTypes.any,
  dashboardFilters: PropTypes.any,
  history: PropTypes.any,
  navegarBreadCrumb: PropTypes.func
}

const mapStatetoProps = state => {
  const { user, dashboardFilters } = state.Login
  const { empresas } = state.Profile
  return { user, empresas, dashboardFilters }
}

export default connect(mapStatetoProps, { navegarBreadCrumb })(
  withTranslation()(withRouter(AiPromptsLista))
)
